import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#69005b',
  width = '100%',
  className = '',
  viewBox = '0 0 87.473 69.978',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      id="umbrella-beach-solid_1_"
      className="icon"
      data-name="umbrella-beach-solid (1)"
      d="M15.77,18.706l13.956,5.082c4.81-11.144,11.783-19.721,19-23.74a40.9,40.9,0,0,0-33.968,15.28,2.188,2.188,0,0,0,1.014,3.379Zm18.075,6.582L66.439,37.156c4.887-16.59,2.556-31.662-5.826-34.713A9.148,9.148,0,0,0,57.457,1.9c-7.93,0-17.531,9.454-23.612,23.392ZM71.273,8.264a31,31,0,0,1,1.8,7.543c.785,6.819-.194,14.792-2.59,22.822l14.026,5.106A2.187,2.187,0,0,0,87.461,41.8,40.921,40.921,0,0,0,71.273,8.264Zm5.265,52.959H43.881l8.876-24.394-8.22-2.993L34.573,61.221H2.187A2.186,2.186,0,0,0,0,63.409v4.375a2.187,2.187,0,0,0,2.187,2.188H76.538a2.187,2.187,0,0,0,2.187-2.188V63.409a2.186,2.186,0,0,0-2.187-2.187Z"
      transform="translate(0 0.006)"
      fill={fill}
    />
  </svg>
);

export default SVG;
